import authService from "./authService";

const API_URL = 'https://uni-func-pd-thrive360.azurewebsites.net/api/mailjetStats';

const mailjetService = {
  async authHeaders() {
    const idToken = await authService.getIdToken();
    return { Authorization: `Bearer ${idToken}` };
  },
  async getStats() {
    try {
      const response = await fetch(API_URL, { headers: await this.authHeaders() });
      if (!response.ok) throw new Error('Failed to fetch Mailjet stats');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Mailjet stats:', error);
      return {
        basicStats: { sent: 0, opened: 0, clicked: 0, openRate: '0%', clickRate: '0%', bounceRate: '0%' },
        eventBreakdown: [],
        recentMessages: []
      };
    }
  }
};

export default mailjetService;


